import { StyleSheet, } from 'react-native';
import { withTheme } from 'react-native-elements';
import { color } from 'react-native-elements/dist/helpers';

const lightTheme = StyleSheet.create({
    closeModalIcon: {
        alignSelf: 'flex-end',
        position: 'absolute',
        top: 0,
        right: 0,
    },

    modal:{
        marginTop: 100,
        justifyContent: "center",
        alignItems: "center",
    },

    titleText: {
        fontSize: 20,
        fontWeight: '600',
        letterSpacing: -0.2,
        color: '#1A1612',
    },

    modalView: {
        height: 300,
    },

    startGameDifficulty: {
        flexDirection: 'row',
        width: 250,
        alignItems: 'center',
        justifyContent: 'center',

    },

    startGameButton: {
        width: 250,
        marginVertical: 8,
        borderRadius: 8,
        overflow: 'hidden',
    },

    modalButton: {
        width: '50%',
        marginLeft: '25%',
        marginTop: 10,
    },

    startGameContainer: {
        alignItems: 'center',
        justifyContent: 'center',
    },
    dominoBorder: {
        borderRightColor: '#ECE7DC',
        borderRightWidth: 1,
    },
    dominoPlayerText: {
        color: "#1A1612",
        fontSize: 9,
        fontWeight: '500',
        letterSpacing: 0.2,
        width: '105%',
        textAlign: 'center',
        marginBottom: 10,

    },
    instructionsText: {
        color: "#4A463E",
        fontSize: 11,
        lineHeight: 16,
        width: '105%',
        textAlign: 'center',
        marginBottom: 10,

    },
    dominoPlayerTextJoin: {
        color: "#4A463E",
        fontSize: 9,
        width: '105%',
        textAlign: 'center',
        marginBottom: 10,
        fontStyle: 'italic',
    },
    dominoScoreText: {
        color: "#1A1612",
        fontSize: 24,
        fontWeight: '600',
        letterSpacing: -0.3,
        width: '105%',
        textAlign: 'center',
        marginBottom: 10,
    },
    dominoPlayer: {
        width: 50,
        alignItems: 'center',
        justifyContent: 'center',
        flex: 1,
        marginLeft: '1%',
        marginRight: '1%',
    },
    dominoPlayerPic: {
        resizeMode: 'cover',
        width: 50,
        height: 50,
        borderRadius: 25,
        marginBottom: 10,
        borderWidth: 1,
        borderColor: '#ECE7DC',
        overflow: 'hidden',
    },
    dominoPlayerButton: {
        width: 64,
        margin: 5,
        borderRadius: 8,
        overflow: 'hidden',
    },
    dominoTableHolder: {
        flexDirection: 'row'
    },
    dominoTableHolderButton: {
        flexDirection: 'row'
    },
    playButton: {
        marginTop: 12,
        marginBottom: 4,
        width: '100%',
        justifyContent: 'center',
        borderRadius: 8,
        overflow: 'hidden',
    },
    modalOverlay: {
        position: 'absolute',
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        backgroundColor: 'rgba(11,15,18,0.55)'
    },
    stickToTop: {
        position: 'absolute',
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        backgroundColor: "#FAF8F4",
    },
    adCard: {
        marginHorizontal: '10%',
        width: '80vw',
        borderRadius: 12,
        borderWidth: 1,
        borderColor: '#ECE7DC',
        shadowColor: '#000',
        shadowOffset: { width: 0, height: 2 },
        shadowOpacity: 0.06,
        shadowRadius: 8,
        elevation: 2,
    },
    newGameCard: {
        marginHorizontal: '10%',
        borderRadius: 12,
        borderWidth: 1,
        borderColor: '#ECE7DC',
        shadowColor: '#000',
        shadowOffset: { width: 0, height: 2 },
        shadowOpacity: 0.06,
        shadowRadius: 8,
        elevation: 2,
    },
    dominoTable: {
        marginHorizontal: '10%',
        borderRadius: 12,
        borderWidth: 1,
        borderColor: '#ECE7DC',
        borderLeftWidth: 3,
        shadowColor: '#000',
        shadowOffset: { width: 0, height: 2 },
        shadowOpacity: 0.06,
        shadowRadius: 8,
        elevation: 2,
    },
    dominoTableCutthroat: {
        borderLeftColor: '#C99231',
    },
    dominoTablePartner: {
        borderLeftColor: '#1F7A2C',
    },
    dominoTableTitleRow: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        paddingHorizontal: 4,
        paddingTop: 2,
        marginBottom: 8,
    },
    dominoTableTitle: {
        fontSize: 17,
        fontWeight: '600',
        letterSpacing: 0.2,
        color: '#1A1612',
        textTransform: 'capitalize',
    },
    statusPill: {
        flexDirection: 'row',
        alignItems: 'center',
        paddingHorizontal: 8,
        paddingVertical: 3,
        borderRadius: 999,
    },
    statusPillWaiting: {
        backgroundColor: 'rgba(217,164,65,0.14)',
    },
    statusPillLive: {
        backgroundColor: 'rgba(31,122,44,0.12)',
    },
    statusPillText: {
        fontSize: 10,
        fontWeight: '600',
        letterSpacing: 0.6,
        textTransform: 'uppercase',
    },
    statusPillTextWaiting: {
        color: '#8A6914',
    },
    statusPillTextLive: {
        color: '#1F7A2C',
    },
    statusDot: {
        width: 6,
        height: 6,
        borderRadius: 3,
        marginRight: 6,
    },
    statusDotWaiting: {
        backgroundColor: '#C99231',
    },
    statusDotLive: {
        backgroundColor: '#1F7A2C',
    },
    dominoPlayerEmpty: {
        width: 50,
        height: 50,
        borderRadius: 25,
        marginBottom: 10,
        borderWidth: 1,
        borderStyle: 'dashed',
        borderColor: '#C9C2B2',
        backgroundColor: 'rgba(31,122,44,0.04)',
        alignItems: 'center',
        justifyContent: 'center',
    },
    dominoPlayerEmptyPlus: {
        fontSize: 22,
        fontWeight: '300',
        color: '#9B947F',
        lineHeight: 24,
    },
    dominoScoreContainer: {
        alignItems: 'center',
        justifyContent: 'center',
        marginBottom: 8,
    },
    dominoScoreLabel: {
        fontSize: 9,
        fontWeight: '600',
        letterSpacing: 1.2,
        color: '#9B947F',
        marginTop: -2,
    },
    teamDivider: {
        width: 1,
        marginHorizontal: 4,
        backgroundColor: '#1F7A2C',
        opacity: 0.35,
    },
    newGameTitle: {
        fontSize: 18,
        fontWeight: '600',
        letterSpacing: 0.2,
        color: '#1A1612',
        marginBottom: 4,
    },
    newGameText: {
        marginBottom: 20,
        textAlign: 'center',
        color: '#4A463E',
        lineHeight: 20,
    },
    newGame: {},
    textInputIcon: {
        height: 40,
        width: 50,
        backgroundColor: '#F2EFE9',
        borderRadius: 8,
        borderWidth: 1,
        borderColor: '#E4E0D6',
        paddingTop: 6
    },
    textInputIconContainer: {
        flex: 1,
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        marginBottom: 20,
    },
    spinnerContainer: {
        marginTop: 40,
    },
    logo: {
        resizeMode: 'contain',
        width: 250,
        height: 100,
    },
    primaryButtonStyle: {

    },
    textInputIconStyle: {
        height: 40,
        width: 200,
        backgroundColor: '#F2EFE9',
        borderRadius: 8,
        borderWidth: 1,
        borderColor: '#E4E0D6',
        paddingHorizontal: 10,
    },
    textInputStyle: {
        height: 40,
        width: 250,
        marginBottom: 20,
        backgroundColor: '#F2EFE9',
        borderRadius: 8,
        borderWidth: 1,
        borderColor: '#E4E0D6',
        paddingHorizontal: 10,
    },
    incorrectPasswordStyle: {
        height: 40,
        width: 250,
        marginBottom: 20,
        backgroundColor: 'rgba(252,213,206,0.4)',
        borderRadius: 8,
        borderWidth: 1,
        borderColor: '#E8B0A6',
        paddingHorizontal: 10,
    },
    signupContainer: {
        flexDirection: 'row',
        flex: 1,
        marginTop: 28,
        marginBottom: 16,
        alignItems: 'center',
        justifyContent: 'center',
    },
    signupContainer2: {
        flexDirection: 'row',
        flex: 1,
        marginTop: 8,
        marginBottom: 8,
        alignItems: 'center',
        justifyContent: 'center',
    },
    formContainer: {
        marginTop: 20,
        alignItems: 'center',
        justifyContent: 'flex-start',
        flex: 6
    },
    signupFormContainer: {
        marginTop: 20,
        alignItems: 'center',
        justifyContent: 'flex-start',
        flex: 12
    },
    logoContainer: {
        alignItems: 'center',
        justifyContent: 'flex-end',
        flex: 5
    },
    tabLogoContainer: {
        alignItems: 'center',
        backgroundColor: '#FAF8F4',
    },
    profPic: {
        resizeMode: 'contain',
        width: 100,
        height: 100,
        borderRadius: 100 / 2
    },
    adIframe:{

    },
    tabLogo: {
        resizeMode: 'contain',
        width: 125,
        height: 50,
    },
    tabLogo2: {
        resizeMode: 'contain',
        width: 64,
        height: 25,
    },
    labelText: {
        textAlign: 'left',
        alignItems: 'flex-start',
        justifyContent: 'flex-start',
        margin: 0,
        padding: 0,
    },
    tabNavContainer: {


    },
    homeMenu: {
        backgroundColor: '#FAF8F4',

    },
    playContent: {
        paddingBottom: "5%",

    },
    container2: {
        flex: 1,
        backgroundColor: "#FAF8F4",
    },
    container: {
        flex: 1,
    },
    genericText: {
        color: "#1A1612",
        marginRight: 6,
    },
    genericText2: {
        color: "#1A1612",
        marginRight: 6,
        alignItems: 'flex-start',
        justifyContent: 'flex-start',
    },
    buttonText: {
        color: "#1F7A2C",
        fontWeight: '600',
        letterSpacing: 0.1,
    },
    errorText: {
        color: "#8E1600",
        fontWeight: '500',
    },
    successText: {
        color: "#1F7A2C"
    },




    // container2: {
    //     flex: 1,
    //     marginTop: StatusBar.currentHeight || 0,
    //   },
    item: {
        backgroundColor: '#f9c2ff',
        padding: 20,
        marginVertical: 8,
        marginHorizontal: 16,
    },
    title: {
        fontSize: 32,
    },
});

const lightStyleTheme = {

    placeholderTextColor: "#acacac",
    primaryButtonColor: "#1F7A2C",
    negativeButtonColor: "#f44336",
    tabNavigation: {
        indicatorStyle: { backgroundColor: "#1F7A2C", height: 3, borderRadius: 2 },
        innerHeight: 500,
        position: 'absolute',
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
    },


}

export { lightTheme, lightStyleTheme };